import tccf7 from './lib/tccf7.js';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wpcf7')?.forEach(elem => { 
    new tccf7(elem);
  });
  
  const url    = new URL(window.location.href);
  const prefix = 'form_complete_token_';
  let   name   = null;
  for (const [key, value] of url.searchParams) {
    if (key.startsWith(prefix)) {
      name = { key, value };
    }
  }
  if( name !== null ) {
    const { key, value } = name;
    url.searchParams.delete(key);
    history.pushState({}, '', url);
  }

});